import { FC } from "react";
import { StyledTime } from "./style";

const TimelineTime: FC = ({ children }) => {
    return <StyledTime>{children}</StyledTime>;
};

export default TimelineTime;
